export default __webpack_public_path__ + "static/media/theWeather.01f4fa49.png";